import { render, staticRenderFns } from "./TopicsListCard.vue?vue&type=template&id=a1f78fd4&scoped=true"
import script from "./TopicsListCard.vue?vue&type=script&lang=js"
export * from "./TopicsListCard.vue?vue&type=script&lang=js"
import style0 from "./TopicsListCard.vue?vue&type=style&index=0&id=a1f78fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f78fd4",
  null
  
)

export default component.exports